import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ToggleSwitch } from '@/components/ui/toggle-switch'

import Toolbar from '../../Toolbar/Toolbar'

const SocialLinkToolbar = ({ onUIToggle }) => {
  const { t } = useTranslation(['social-link'])

  return (
    <div className="social-link-toolbar">
      <div className="social-link-toolbar__wrapper">
        <Toolbar
          routes={[
            {
              path: '/dashboard/building-dashboard/social-links/legacy',
              name: t('social-link:toolbar.socialLinkTab'),
            },
            {
              path: '/dashboard/building-dashboard/social-links/legacy/reviews',
              name: t('social-link:toolbar.reviewsTab'),
              hidden: true,
            },
          ]}
        />
        <ToggleSwitch
          size="small"
          falsyLabel={t('social-link:toolbar.oldDesignLabel')}
          truthyLabel={t('social-link:toolbar.newDesignLabel')}
          checked={false}
          onChange={onUIToggle}
        />
      </div>
    </div>
  )
}

SocialLinkToolbar.propTypes = {
  onUIToggle: PropTypes.func,
}

export default SocialLinkToolbar
